<script lang="ts" setup>
import BaseButton from "@/components/Base/Button.vue";

defineOptions({ name: "CableConnectionAlert" });

const { t } = useI18n();
const cableConnectionStore = useCableConnectionStore();

const reload = (): void => {
  window.location.reload();
};
</script>

<template>
  <div
    v-if="cableConnectionStore.isLost"
    class="cable-connection-alert"
    data-test="cable-connection-alert"
  >
    <div
      class="alert alert-warning d-flex align-items-center gap-3 mb-0"
      role="alert"
    >
      <div>
        <strong>{{ t("errors.liveConnectionLost.title") }}</strong>
        <p class="mb-0">{{ t("errors.liveConnectionLost.description") }}</p>
      </div>
      <BaseButton
        kind="secondary"
        size="s"
        data-testid="button-reload_after_connection_lost"
        @click="reload"
      >
        {{ t("errors.liveConnectionLost.reload") }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cable-connection-alert {
  position: fixed;
  right: $spacer-2;
  bottom: $spacer-2;
  left: $spacer-2;
  // higher than navbar, same layer as the incognito banner
  z-index: 1060;
  font-size: $font-size-sm;

  @include media-breakpoint-up(md) {
    left: auto;
    max-width: 30rem;
  }
}
</style>
